import { useState, useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { ResolveBaseApiUrl } from './Utility';
import eventBus from './eventBus';


export const GetNotifications = (props) => {
    const baseUrl = ResolveBaseApiUrl();
    const [ connection, setConnection ] = useState(null);
    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}notificationHub`)
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    connection.on('ReceivedAlert', message => {
                       eventBus.dispatch("notification",{message : message});
                    });
                })
                .catch(e => console.log('Notification connection failed :('));
        }
    }, [connection]);
    
};